<template>
  <!-- 上/下游结算规则 -->
  <div>
    <div class="tools-box left">
      <!-- 商户可以配置下游规则或者外部产品的上游规则 -->
      <Button type="primary" @click="$refs.settlementDescForm.open({}, 'add', false)" v-if="hasEdit">新增</Button>
      <Button type="primary" @click="copyData" v-if="type == 'downstream'">复制上游结算规则</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="content">
          <div v-html="row.content"></div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <span v-if="index != 0" class="table-btn" @click="moveUp(index)"><i class="iconfont iconyidong-xiangshang"></i></span>
          <span v-if="tableData.length != index + 1" class="table-btn" @click="moveDown(index)"><i class="iconfont iconyidongxiangxia"></i></span>
          <span class="table-btn" :class="{ 'disabled': productForm.dockChannel == 3 }" @click="$refs.settlementDescForm.open(row, index, true)">编辑</span>
          <span class="table-btn red" :class="{ 'disabled': productForm.dockChannel == 3 }" @click="del(index)">删除</span>
        </template>
      </Table>
    </div>

    <!-- 新增/编辑流程表单 -->
    <settlement-desc-form ref="settlementDescForm" @success="setData" :tableData="tableData" :productForm="productForm" :type="type"></settlement-desc-form>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import settlementDescForm from './settlementDescForm';
import confirmModal from '@/components/commons/confirmModal';
export default {
  components: {
    settlementDescForm,
    confirmModal
  },
  props: {
    type: {
      // upstream:上游 downstream:下游
      default: 'upstream'
    }
  },
  data() {
    return {
      listLoading: false,
      formData: {},
      productForm: {},
      tableData: [],
      columns: []
    };
  },
  computed: {
    // 是否可编辑 商户可以配置下游规则或者外部产品的上游规则
    hasEdit() {
      const productForm = this.productForm;
      if (!productForm || !productForm.id) {
        return false;
      }
      if ((productForm.sourceType != 1 && productForm.dockChannel != 3) || this.type == 'downstream') {
        return true;
      }
      return false;
    },
  },
  mounted() {},
  methods: {
    init(productForm) {
      this.productForm = productForm;
      const settleRule = this.type == 'upstream' ? this.productForm.settleRule : this.productForm.subordinateSettleRule;
      if (settleRule) {
        this.tableData = JSON.parse(settleRule);
      } else {
        this.tableData = [];
      }
      this.getColumns();
    },
    getColumns() {
      const columns = [
        {
          title: '标题',
          key: 'name',
          width: 300,
          align: 'center'
        },
        {
          title: '介绍',
          slot: 'content',
          minWidth: 600,
        }
      ];
      if (this.hasEdit) {
        columns.push({
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center'
        });
      }
      this.columns = columns;
    },
    setData(data) {
      this.tableData = data;
      if (this.type == 'upstream') {
        this.productForm.settleRule = JSON.stringify(data);
      } else {
        this.productForm.subordinateSettleRule = JSON.stringify(data);
      }
    },
    // 复制上游数据
    copyData() {
      if (!this.productForm.settleRule || this.productForm.settleRule == '[]') {
        this.$notice.error('无可复制内容');
        return;
      }
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '是否确定将上游结算规则完整复制到对下结算规则？'
        })
        .then(async () => {
          const list = JSON.parse(this.productForm.settleRule);
          this.save(list);
        });
    },
    // 上移
    moveUp(index) {
      const list = JSON.parse(JSON.stringify(this.tableData));
      const data = list[index - 1];
      list[index - 1] = list[index];
      list[index] = data;
      this.save(list);
    },
    // 下移
    moveDown(index) {
      const list = JSON.parse(JSON.stringify(this.tableData));
      const data = list[index + 1];
      list[index + 1] = list[index];
      list[index] = data;
      this.save(list);
    },
    // 删除
    del(index) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(async () => {
          const list = JSON.parse(JSON.stringify(this.tableData));
          list.splice(index, 1);
          this.save(list);
        });
    },
    save(list) {
      let ajaxConfig, dataKey;
      if (this.type == 'upstream') {
        dataKey = 'settleRule';
        ajaxConfig = {
          url: '/buz/productBase/updateSettleRule',
          type: 'POST',
          data: {
            id: this.productForm.id,
            settleRule: list
          }
        };
      } else {
        dataKey = 'subordinateSettleRule';
        ajaxConfig = {
          url: '/buz/productBase/updateSubSettleRule',
          type: 'POST',
          data: {
            productCode: this.productForm.productCode,
            subordinateSettleRule: list
          }
        };
      }
      if(this.listLoading) {
        return;
      }
      this.listLoading = true;
      this.$http(ajaxConfig).then(res => {
        this.tableData = list;
        this.productForm[dataKey] = JSON.stringify(this.tableData);
      }).finally(()=>{
        window.setTimeout(() => {
          this.listLoading = false;
        }, 500)
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
